module.exports = __webpack_public_path__ + "static/media/btn_ck.a6c00b3f.png";